import axios, { AxiosResponse } from 'axios';
import { IServiceResult } from '../../Interfaces/IServiceResult';
import { ServiceResult } from './ServiceResult';

import { con } from '../../../application/entity/Rutas';

export class SVCContrato {
    public static async ObtieneContrato(headers: any, codigoNegocio: number, codigoPrograma: string, rut: number, download: boolean, agnoPromocion: number, codigoPlanificacionAcademica: number, incluirFirmaUDD: boolean, idPeriodo: number, idPersona: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRutaBFF();
        const url: string = _ruta + "PostGeneracionContratoPorAlumnoYCarrera";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .post(url, {

                'codigoNegocio': codigoNegocio,
                'codigoPrograma': codigoPrograma,
                'rut': rut,
                "codigoPlanificacionAcademica": codigoPlanificacionAcademica,
                "agnoPromocion": agnoPromocion,
                "incluirFirmaUDD": incluirFirmaUDD,
                "idPeriodo": idPeriodo,
                "idPersona": idPersona

            }, { headers })
            .then((res: AxiosResponse) => {
                /* console.log(res)
                console.log(res.data[0]) */
                const raw = window.atob(res.data[0])
                const rawlength = raw.length;
                const blobArray = new Uint8Array(new ArrayBuffer(rawlength));

                for (let i = 0; i < rawlength; i++) {
                    blobArray[i] = raw.charCodeAt(i);
                }

                const blob = new Blob([blobArray], { type: 'application/pdf' });

                var fileURL = URL.createObjectURL(blob);
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.download = "Contrato.pdf";

                //window.location.assign(fileURL);
                if (download)
                    fileLink.click();
                else
                    window.open(fileURL)

                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
    public static obtenerReader = async (r: any) => {
        /* console.log(r.data) */
        const reader = await r.data.getReader();
        let by: any = [];
        while (true) {
            const { done, value } = await reader.read();

            if (value !== undefined) {
                console.log(`Received ${value.length} bytes`);
                by.push(value);
            }

            if (done) {
                break;
            }
        }
        return by;
    }

    // public static async ObtieneContratoPDF(codigoNegocio: number, codigoPrograma: string, rut: number, download: boolean) {
    //     let _ruta: string = con.RetornaRuta();
    //     const url: string = _ruta + "GeneracionContrato/getDescargarContrato";
    //     fetch(url, {
    //         method: 'POST',
    //         headers: {
    //             'Content-Type': 'application/pdf',
    //         }
    //     }).then((response) => response.blob())
    //         .then((blob) => {
    //             const url = window.URL.createObjectURL(new Blob([blob]),);
    //             const link = document.createElement('a');
    //             link.href = url;
    //             link.setAttribute(
    //                 'download',
    //                 `Contrato.pdf`
    //             );

    //             document.body.appendChild(link);

    //             link.click()
    //         })
    // }

    public static async EstadoFirmaEcert(
        rut: number,
        codigoPrograma: string,
        estado: boolean): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "CorreoFirmas/estadoFirmaEcert";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        let data: any[] = [];
        await axios
            .post(url,
                data,
                {
                    params: {
                        'rut': rut,
                        'codCarr': codigoPrograma,
                        'estado': estado
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                    //console.log(sr.result )
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async eCert_firma(
        idProceso: number,
        rut: number,
        anoPromocion: number,
        periodoPromocion: number,
        numeroAlumno: string,
        tipoPersona: number,
        idPeriodo: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "GeneracionContrato/getAutenticar";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .post(url, {
                'idProceso': idProceso,
                'rut': rut,
                'agnoPromocion': anoPromocion,
                'periodoPromocion': periodoPromocion,
                'numeroAlumno': numeroAlumno,
                'tipoPersona': tipoPersona,
                "idPeriodo": idPeriodo,
                "idRefirma": 0
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                    //console.log(sr.result )
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneFirma(
        codigoNegocio: number, idProceso: number, idPeriodo: number, esMenorEdad: boolean, idRefirma: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "GeneracionContrato/getTipoPersonaFirmaContrato";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .post(url, {
                "codigoNegocio": codigoNegocio,
                "idProceso": idProceso,
                "idPeriodo": idPeriodo,
                "EsMenorEdad": esMenorEdad,
                "idRefirma": idRefirma ?? 0
            })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                    //console.log(sr.result )
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
    public static async EnviarToken(
        token: string, codigo: string): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "GeneracionContrato/getFirma?token=" + token + "&codigo=" + codigo;
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .post(url,
                {
                    params: {
                        'token': token,
                        'codigo': codigo
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                    //console.log(sr.result )
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
    public static async ObtieneExcepcion(
        rut: number,
        codigoExcepcion: number,
        codigoNegocio: number,
        anio: number,
        periodo: number,
        codigoPrograma: string): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "ClienteExcepcion/TieneExcepcion";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .post(url,
                {
                    'rut': rut,
                    'codigoExcepcion': codigoExcepcion,
                    'codigoNegocio': codigoNegocio,
                    'anio': anio,
                    'periodo': periodo,
                    'codigoPrograma': codigoPrograma
                },
                {
                    params: {
                        'rut': rut,
                        'codigoExcepcion': codigoExcepcion,
                        'codigoNegocio': codigoNegocio,
                        'anio': anio,
                        'periodo': periodo,
                        'codigoPrograma': codigoPrograma
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
    public static async ObtieneExcepcionPrograma(
        codigoExcepcion: number,
        codigoNegocio: number,
        codigoCarrera: string,
        anio: number,
        periodo: number,
        codigoPlanificacion: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "ProgramaExcepcion/getTieneExcepcion";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .post(url,
                {
                    'codigoExcepcion': codigoExcepcion,
                    'codigoNegocio': codigoNegocio,
                    'codigoCarrera': codigoCarrera,
                    'anio': anio,
                    'periodo': periodo,
                    'codigoPlanificacion': codigoPlanificacion
                },
                {
                    params: {
                        'codigoExcepcion': codigoExcepcion,
                        'codigoNegocio': codigoNegocio,
                        'codigoCarrera': codigoCarrera,
                        'anio': anio,
                        'periodo': periodo,
                        'codigoPlanificacion': codigoPlanificacion
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneContratoManual(
        rut: number,
        idProceso: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "ContratoManual/getContratoManual";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .post(url,
                {
                    'rut': rut,
                    'idProceso': idProceso
                },
                {
                    params: {
                        'rut': rut,
                        'idProceso': idProceso
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async ObtieneContratoWeb(
        rut: number,
        codCarrera: string): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "ContratoManual/getBaseContrato";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .post(url,
                {
                    'rut': rut,
                    'codigoCarrera': codCarrera
                },
                {
                    params: {
                        'rut': rut,
                        'codigoCarrera': codCarrera
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async BajarContratoManual(
        rut: number,
        idProceso: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "ContratoManual/getContratoManual";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .post(url,
                {
                    'rut': rut,
                    'idProceso': idProceso
                },
                {
                    params: {
                        'rut': rut,
                        'idProceso': idProceso
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    const raw = window.atob(res.data)
                    const rawlength = raw.length;
                    const blobArray = new Uint8Array(new ArrayBuffer(rawlength));

                    for (let i = 0; i < rawlength; i++) {
                        blobArray[i] = raw.charCodeAt(i);
                    }

                    const blob = new Blob([blobArray], { type: 'application/pdf' });

                    var fileURL = URL.createObjectURL(blob);
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.download = "Contrato.pdf";

                    window.open(fileURL)
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async BajarContrato(
        rut: number,
        codCarrera: string): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "ContratoManual/getBaseContratoManual";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        let data: any[] = [];
        await axios
            .post(url,
                data,
                {
                    params: {
                        'rut': rut,
                        'codigoCarrera': codCarrera
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    const raw = window.atob(res.data)
                    const rawlength = raw.length;
                    const blobArray = new Uint8Array(new ArrayBuffer(rawlength));

                    for (let i = 0; i < rawlength; i++) {
                        blobArray[i] = raw.charCodeAt(i);
                    }

                    const blob = new Blob([blobArray], { type: 'application/pdf' });

                    var fileURL = URL.createObjectURL(blob);
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    fileLink.download = "Contrato.pdf";

                    /* window.open(fileURL) */
                    /* fileLink.click(); */
                    window.location.assign(fileURL);
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async InsertaContratoManual(
        rut: number,
        idProceso: number,
        anoPromocion: number,
        periodoPromocion: number,
        numeroAlumno: string,
        base64: string,
        idPeriodo: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "ContratoManual/updateContratoManual";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        //let data: any = [];
        await axios
            .post(url, {
                'rut': rut,
                'idProceso': idProceso,
                'anoPromocion': anoPromocion,
                'periodoPromocion': periodoPromocion,
                'numeroAlumno': numeroAlumno,
                'base64': base64,
                "idPeriodo": idPeriodo
            }
            )
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    public static async QuitarContratoManual(
        rut: number,
        idProceso: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "ContratoManual/deleteContratoManual";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        await axios
            .post(url,
                {
                    'rut': rut,
                    'idProceso': idProceso
                },
                {
                    params: {
                        'rut': rut,
                        'idProceso': idProceso
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }

    // public static async ObtenerFirmaContrato(
    //     rut: number,
    //     codCarrera: string,
    //     codigoPlanificacion: number): Promise<IServiceResult<any>> {
    //     let _ruta: string = con.RetornaRuta();
    //     const url: string = _ruta + "GeneracionContrato/getFirmaContrato";
    //     let sr: ServiceResult<any> = new ServiceResult<any>();
    //     sr.errorMessage = "Inicializando invocación";
    //     //let data: any[] = [];
    //     await axios
    //         .get(url,
    //             {
    //                 params: {
    //                     'rut': rut,
    //                     'programa': codCarrera,
    //                     'codigoPlanificacion': codigoPlanificacion
    //                 }
    //             })
    //         .then((res: AxiosResponse) => {
    //             if (res.data !== undefined) {
    //                 sr.result = res.data;
    //             }
    //         })
    //         .catch((err: any) => {
    //             sr.errorMessage = "Error al leer";
    //             sr.errorDetails = err;
    //         });

    //     return sr;
    // }

    public static async ObtieneTieneFirmaContrato(
        codigoNegocio: number,
        rut: number,
        codigoPrograma: string,
        anioPromocion: number,
        periodoPromocion: number,
        codigoPlanificacion: number): Promise<IServiceResult<any>> {
        let _ruta: string = con.RetornaRuta();
        const url: string = _ruta + "GeneracionContrato/getTieneFirmaContrato";
        let sr: ServiceResult<any> = new ServiceResult<any>();
        sr.errorMessage = "Inicializando invocación";
        //let data: any[] = [];
        await axios
            .get(url,
                {
                    params: {
                        'codigoNegocio': codigoNegocio,
                        'rut': rut,
                        'codigoPrograma': codigoPrograma,
                        'anioPromocion': anioPromocion,
                        'periodoPromocion': periodoPromocion,
                        'codigoPlanificacionAcademica': codigoPlanificacion
                    }
                })
            .then((res: AxiosResponse) => {
                if (res.data !== undefined) {
                    sr.result = res.data;
                }
            })
            .catch((err: any) => {
                if (err.response && (err.response.status === 401 || err.response.status === 403)) {
                    sr.errorMessage = err.response.data;
                } else {
                    sr.errorMessage = "500";
                }
                sr.errorDetails = sr.errorMessage;
            });

        return sr;
    }
}